import {DeviceType, NodeObject} from "@syginc/tellus-aomjs";

import {IAquaEditor} from "../editor/aqua-editor";

export function renderSourceHtml(aquaEditor: IAquaEditor, node: NodeObject) {
    return aquaEditor.aomRenderer.renderToHtml(node, {deviceType: DeviceType.Source});
}
